// extracted by mini-css-extract-plugin
module.exports = {"collapse":"f3efdc22c9acb93401f8efe068fd923c-less","collapse-header":"_8a5dfcf57ab4fadab83d84a3101d8093-less","collapseHeader":"_8a5dfcf57ab4fadab83d84a3101d8093-less"};